import React, { useLayoutEffect } from "react";
import "./App.scss";
import Home from "./Home";
import Script from "./Script";
import TheShelf from "./TheShelf";
import ScreeningRoom from "./ScreeningRoom";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import {
  disableScrollRestoration,
  holdPageAtTop,
  resetPageScroll,
} from "./resetPageScroll";

disableScrollRestoration();

function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    resetPageScroll();
    return holdPageAtTop(pathname === "/screening-room" ? 8000 : 600);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <div>
          <Routes>
            <Route path="/showcase-prototype" element={<Script />} />
            <Route path="/the-shelf" element={<TheShelf />} />
            <Route path="/screening-room" element={<ScreeningRoom />} />
            <Route path="/" element={<Home />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
